import React from "react";
import ActionsPopup from "../../ProfilesDetail/Table/ActionsPopup";
import schema from "../../ProfilesDetail/Table/ActionsPopup/agent_attorney_actions";

const foreign_worker_columns = (formApi, linkedProfiles, setLinkedProfiles) => [
  {
    Header: "Profile Name",
    id: "new_group_fw_group_name",
    accessor: (data) => data.new_group_fw_group_name,
    Cell: ({ value }) => {
      return <span>{value}</span>;
    },
  },
  {
    Header: "Actions",
    id: "actions",
    accessor: "actions",
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => {
      return (
        <ActionsPopup
          actionsPopupSchema={schema("foreign-worker-group", true)}
          id={original.id}
          removeLinkedProfile={true}
          formApi={formApi}
          linkedProfilesMachineName="new_group_fw_groups"
          removedProfilesMachineName="removed_fw_groups"
          linkedProfiles={linkedProfiles}
          setLinkedProfiles={setLinkedProfiles}
        />
      );
    },
  },
];

export default foreign_worker_columns;
